import {Directive, ElementRef, Input, Renderer2, HostListener, OnInit, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {NgEventBus} from 'ng-event-bus';

@Directive({
    selector: '[nlrTooltip]',
    standalone: true
})
export class NlrTooltipDirective implements OnInit {
    @Input('nlrTooltip') tooltipText = '';
    @Input('nlrTooltipPosition') tooltipPosition: 'top' | 'bottom' = 'top';
    @Input('nlrTooltipParent') tooltipParent = '';
    private tooltipElement: HTMLElement | null = null;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private eventBus: NgEventBus,
        private destroyRef: DestroyRef
    ) {}

    ngOnInit() {
        if (this.tooltipParent) {
            // listen for external close event for the tooltip
            this.eventBus
                .on(`${this.tooltipParent}:tooltipClose`)
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(() => this.closeTooltip());
        }
    }

    @HostListener('mouseenter') onMouseEnter() {
        if (!this.tooltipElement) {
            this.createTooltip();
        }
    }

    @HostListener('mouseleave') onMouseLeave() {
        this.closeTooltip();
    }

    private createTooltip() {
        this.tooltipElement = this.renderer.createElement('span');
        this.renderer.appendChild(this.tooltipElement, this.renderer.createText(this.tooltipText));
        this.renderer.setProperty(this.tooltipElement, 'innerHTML', this.tooltipText.replace(/\n/g, '<br>'));

        this.renderer.addClass(this.tooltipElement, 'tooltip-custom');
        this.renderer.appendChild(document.body, this.tooltipElement);

        const rowRect = this.el.nativeElement.getBoundingClientRect();
        const tooltipRect = this.tooltipElement.getBoundingClientRect();

        switch (this.tooltipPosition) {
            case 'top':
                this.renderer.setStyle(this.tooltipElement, 'top', `${rowRect.top + window.scrollY - tooltipRect.height - 5}px`);
                this.renderer.setStyle(this.tooltipElement, 'left', `${rowRect.left + window.scrollX + rowRect.width / 2 - tooltipRect.width / 2}px`);
                this.renderer.setAttribute(this.tooltipElement, 'data-position', 'top');
                break;
            case 'bottom':
                this.renderer.setStyle(this.tooltipElement, 'top', `${rowRect.top + window.scrollY + 40}px`);
                this.renderer.setStyle(this.tooltipElement, 'left', `${rowRect.left + window.scrollX + rowRect.width / 2 - tooltipRect.width / 2}px`);
                this.renderer.setAttribute(this.tooltipElement, 'data-position', 'bottom');
                break;
            default:
                this.renderer.setStyle(this.tooltipElement, 'top', `${rowRect.top + window.scrollY + 40}px`);
                this.renderer.setStyle(this.tooltipElement, 'left', `${rowRect.left + window.scrollX + rowRect.width / 2 - tooltipRect.width / 2}px`);
                this.renderer.setAttribute(this.tooltipElement, 'data-position', 'top');
        }
    }

    private closeTooltip() {
        if (this.tooltipElement) {
            this.renderer.removeChild(document.body, this.tooltipElement);
            this.tooltipElement = null;
        }
    }
}
